/**
 * @module components
 * @package @geenius/adapters/react-heroui
 * @description Public HeroUI component wrappers for the React adapter
 * reference surface.
 */

"use client";

import {
  type AdapterCardProps,
  type AdapterConfigFormProps,
  type AdapterListProps,
  type AdapterStatusBadgeProps,
  AdapterCard as ReferenceAdapterCard,
  AdapterConfigForm as ReferenceAdapterConfigForm,
  AdapterList as ReferenceAdapterList,
  AdapterStatusBadge as ReferenceAdapterStatusBadge,
} from "@geenius/adapters/react";

export type {
  AdapterCardProps,
  AdapterConfigFormProps,
  AdapterListProps,
  AdapterStatusBadgeProps,
};

export function AdapterCard(props: AdapterCardProps) {
  return <ReferenceAdapterCard {...props} />;
}

export function AdapterConfigForm(props: AdapterConfigFormProps) {
  return <ReferenceAdapterConfigForm {...props} />;
}

export function AdapterList(props: AdapterListProps) {
  return <ReferenceAdapterList {...props} />;
}

export function AdapterStatusBadge(props: AdapterStatusBadgeProps) {
  return <ReferenceAdapterStatusBadge {...props} />;
}
